import { environment } from 'src/environments/environment';

export const API_ENDPOINTS = {
    BASE_URL: environment.url,
    CHAT_URL: environment.chat_url,
    VERSION: '/v1',
    DEVICES: '/devices',
    DELETE_DEVICES: '/delete_device',
    API: {
        ACTIVE_SUBSCRIPTION: '/active_subscription',
        ACCOUNT_TRANSACTIONS: '/account_transactions',
        AUTH: {
            AUTH: '/auth',
            LOGIN: '/login',
            LINKEDIN: '/linkedin',
            SIGN_UP: '/signup',
            CONFIRMATION: '/confirmation',
            PASSWORD: '/password',
        },
        AVERAGE_RATINGS: '/average_ratings',
        BUSINESS_PROFILE: '/business_profiles',
        BUSINESS: '/businesses',
        CANCEL_SUBSCRIPTION: '/cancel_subscription',
        CHANGE_PASSWORD: '/change_password',
        CHANGE_PRIVACY_SETTING: '/change_privacy_settings',
        CONTENTS: '/contents',
        CONTACTS: '/contacts',
        CONTET_OPERATIONS: '/content_operations',
        COLLECTION_BY_SLUG: '/collection_by_slug',
        SHARE_INVITE: '/users/share_invite',
        CONFIRM_AND_UPDATE : '/confirm_and_update_account',
        SHARE: '/share',
        REMOVE: '/remove',
        HOT_DEAL: '/hot_deal',
        MOST_POPULAR_VIDEO: '/most_popular',
        CONNECTIONS: '/connections',
        REPORT_CONNECTION: '/report_connections',
        REPORT_CONTENT: '/report_content',
        CURRENCY_CONVERTER: '/currency_converter',
        CONVERT: '/convert',
        FETCH_BLOCKED_CONNECTIONS: '/fetch_blocked_connections',
        FETCH_BLOCKED_CONTENT_AND_CONNECTION: '/block_requests',
        UNBLOCK_CONTENT_AND_CONNECTION: '/unblock_request',
        FETCH_TOKENS: '/fetch_tokens',
        GIFT_TOKENS: '/gifted',
        TRANSFER_TOKENS: '/transferred',
        FETCH_GIFTED_TOKENS: '/pending_gifted_tokens',
        APPROVE_REJECT_GIFTED_TOKENS: '/approve_decline_tokens',
        GET_TAGGED_INTEREST_TO_USERS: '/tagged_interests/tagged_interest_of_user',
        GET_PACKAGES: '/packages',
        INTERESTS: '/interests',
        INDUSTRIES: '/industries',
        LOCATIONS: '/locations',
        MUTE_CONNECTION: '/mute_connections',
        OTP: '/otp',
        USER_CONNECTION: '/user_connections',
        SETTING_BASED_CONNECTION: '/setting_based_connections',
        VERIFY_OTP: '/verify_number',
        PERMISSION: '/user_permissions',
        PLAN: '/plans',
        PROFILE_SETTINGS: '/user_profile_settings',
        SEARCH: '/search',
        SUBSCRIPTIONS: '/subscriptions',
        CHECK_BBB_PLAN: '/subscriptions/ios_bbb_plan_check',
        BBB_PLAN_CONFIRMATION: '/subscriptions/bbb_plan_confirmation',
        UPDATE_PLAN_CARD_FLAG: '/subscriptions/update_plan_card_flag',
        AUTO_RENEW_SUBSCRIPTION: '/subscriptions/enable_auto_renew_subscription',
        SUPPLEMENTARY_USERS: '/supplementary_accounts',
        TRANSACTION_DETAILS: '/transaction_details',
        PENDING_CONTENTS: '/pending_contents',
        APPROVE_DECLINE_CONTENT: '/approve_decline_content',
        SUPPLEMENTARY_USER_AVATAR: '/update_image',
        SUGGESTED_CONNECTIONS: '/suggested_connections',
        TAGGED_INTEREST_TO_USERS: '/tagged_interests',
        PACKAGES: '/packages',
        TESTIMONIALS: '/testimonials',
        PRESIGNED_URL: '/get_presigned_url',
        BROWSED_MATERIAL: '/browsed_material',
        EDITORS_CHOICE: '/editor_picks',
        EDITOR_VIDEO: '/editor_video',
        TRENDING_CONTENTS: '/trending_contents',
        MARKETPLACE_CONTENT: '/sd_trending_contents',
        OTHER_PROFILE: '/fetch_other_user_details',
        TOKENS: '/tokens',
        RECENT_PAYMENT_STATUS: '/recent_payment_status',
        USERS: '/users',
        CANCEL_PAYMENT: '/cancel_payment',
        USER_CONFIRMED: '/user_confirmed',
        OTHER_USER_CONTENT: '/show/user_content',
        CART: '/cart_items',
        PLAYLIST: '/content_collections',
        PURCHASED_CONTENT: '/purchase',
        PURCHASE_COLLECTION: '/collection/direct_purchase',
        GIFT: '/gifted_contents',
        SUPP_SENT_CONTENT_LIST: '/supplementary_sent_content_list',
        GIFT_SAVE_TO_PRIVATE: '/gift_save_to_private_lib',
        MAKE_PRIMARY_ACCOUNT: '/make_primary_account',
        REGIFT: '/regift',
        PENDING_GIFTS: '/gifted_contents/list_pending',
        ACCEPT_REJECT_GIFT: '/content_operations/approve_decline_contents',
        ADVERTISEMENT: '/promotions',
        CHECK_VALID: '/check_valid',
        ADVERTISEMENT_PRESIGNED_URL: '/get_presigned_url_for_advsemnt',
        ADVERTISEMENT_ACCEPT_REJECT: '/accept_decline_promotions',
        ADVERTISEMENT_SEARCH: '/search',
        CANCEL_ADVERTISEMENT: '/cancel_adv_request',
        ACCEPTED_PUBLIC_ADVERTISEMENT: '/accepted_pp_promotions',
        DELETE_PLAYLIST_CONTENT: '/collection/delete_content',
        CHECK_PASSWORD: '/password_confirmation_in_disable_account',
        DEACTIVATE_ACC: '/users/disable_account',
        PUBLIC_PROFILE_ADVERTISEMENTS: '/public_profile_promotions',
        OWNED_PUBLIC_ADVERTISEMENT: '/owned_public_promotion',
        UPDATE_AVATAR: '/update_avatar',
        UPDATE_COVER: '/update_cover',
        RELATED_BOOKS: '/related_contents',
        USER_REQUEST_VERIFICATION: '/user_request_verification',
        PUBLISH_TO_PUBLIC_LIBRARY: '/publish_to_public_library',
        USER_VERIFICATION_DETAIL: '/user_verification_details',
        GET_VERIFICATION_PROOFS: '/get_verification_proofs',
        USER_CATEGORY: '/user_categories',
        DIRECT_PURCHASE: '/content/direct_purchase',
        CLEAR_CART: '/clear',
        VALID_RESET_TOKEN: '/valid_reset_token',
        UPGRADE_SUBSCRIPTION: '/upgrade_subscription',
        APPROVED_DECLINED_TESTIMONIAL: '/approve_decline_testimonials',
        RECENT_ACTIVITY: '/recent_activities',
        MATERIAL: '/materials',
        SUGGESTED_CONTENTS: '/suggested_contents',
        NOTIFICATIONS: '/notifications',
        ANALYTICS: '/analytics',
        PUBLISH_PLAYLIST: '/content_collections',
        PUBLISH_PACKAGE: '/publish_content_collection',
        SAME_COLLECTION_PUBLISHED: '/is_same_collection_published',
        PUBLISHES_COUNT: '/publishes_count',
        BLOCK_USERS_AND_CONETENT: '/block_requests',
        ADD_SONGS_VIDEOS: '/collection/add_content',
        MATERIAL_PROMOTION: '/material_promotions',
        CHECK_PERMISSION: '/check_permission',
        MY_CONTENT: '/my_contents',
        SHIFT_CONTENT_PLAYLIST: '/collection/shift_content',
        RESERVED_SLOTS: '/reserved_slot',
        GET_CHAT_USERS: '/users',
        MESSAGE_LIST: '/direct_messages',
        CHAT_ROOMS: '/chatrooms',
        MESSAGES: '/messages',
        USER_OUTLETS: '/user_outlets',
        OUTLET_CONTENTS: '/get_outlet_content',
        TIME_MATRIX: '/time_matrices',
        USER_OUTLETS_CATEGORIES: '/outlet_categories',
        OUTLETS_INDIVIDUAL_CUSTOMER: '/outlets_individual_customer',
        REMOVE_CONTENT_FROM_SPECIFIC_OUTLET:'/remove_content_from_specific_outlet',
        FETCH_USER_ADDITIONAL_PUBLIC_LIBRARY: "/fetch_user_additional_public_laibrary",
        ASSIGN_CONTENT_TO_SPECIFIC_OUTLET: "/assign_content_to_specific_outlet",
        OUTLET_SUBSCRIBERS: "/outlet_subscribers",
        JOINED_CHANNELS: '/joins_channel',
        GET_SETTINGS: "/get_settings",
        UPDATE_SETTINGS: "/update_settings",
        QR_CODE: "/qrcodes",
        LIST_ADD_ONS: "/list_add_ons",
        PURCHASE_ADD_ONS: '/purchase_add_on',
        LIST_SENT_CONTENT: '/list_sent_contents',
        LIST_SENT_GIFT: '/list_sent_gifts',
        CHAT_LIST: '/chat_list',
        NOTIFICATION_CHAT_LIST: '/notification_chat_list',
        SINGLE_CHAT_CONNECTION : '/user_single_chat_connection',
        PUBLIC_CONTENTS: '/public_contents',
        EVENT_REGISTRATION: '/event_registrations',
        SUBSCRIBERS: '/subscribers',
        WITHDRAW_REQUEST: '/withdraw_requests',
        SAVED_ACCOUNTS: '/saved_accounts',
        PURCHASED_ADD_ONS: '/purchased_add_ons',
        SUPP_CONNECTIONS: '/supplementary_connections',
        GET_USER_STATUS: '/get_user_current_status',
        DIRECT_PURCHASE_PLAYLIST: '/collection/direct_purchase',
        UPDATE_CART_ITEMS: '/update_cart_items',
        SLOTS: '/slots',
        UPDATESLOTS: '/update_slots',
        TEMPLATES: '/templates',
        MATERIAL_TEMPLATES: '/material_templates',
        WIPOD_CONTENT_CREATE: '/wipod_doc_content_creation',
        WIPOD_PUBLISH_TO_PRIVATE: '/upload_wipod_content_to_private_library',
        WIPOD_DOC_UPDATE: '/wipod_doc_content_updation',
        SCRIPTDOOR_ADVERTISEMENT: '/scriptdoor_advertisements',
        FETCH_ADVERTISEMENT: '/fetch_advertisement',
        COLLABORATIONS: '/collaborations',
        OWNER_COLLAB_CONTENT: '/owners_collaborated_content',
        OTHER_USERS_COLLAB_CONTENT: '/other_users_collaborated_content',
        LIST_PENDING_COLLABORATION: '/list_pending_collaboration',
        CONTENT_COLLABORATOR_LIST: '/content_collaborators_list',
        APPROVED_DECLINED_COLLABORATION: '/approve_decline_collaboration',
        CONTENT_TEXTS: '/content_texts',
        UPDATE_COLLABORATOR_CONTENT_TEXT: '/update_collaborator_content_text',
        SHOW_WIPOD_CONTENT: '/show_wipod_content',
        GET_STATUS: '/get_status',
        COLLABORATION_LOCKED: '/collaboration_locked',
        COLLABORATION_UNLOCKED: '/collaboration_unlocked',
        CREDIT_CARDS: '/credit_cards',
        AUTO_RENEW_ADD: '/auto_renew_add',
        UPGRADE_LIBRARY_SUBSCRIPTION: '/upgrade_library_subscription',
        REMOVE_WIPOD: '/remove_wipod',
        COLLABORATOR_DELETE_COLLABRATION: '/collaborator_delete_collaboration',
        GROUPS: '/groups',
        ADD_USER_INTO_GROUP: '/add_user_into_group',
        REMOVE_USER_FROM_GROUP: '/remove_user_from_group',
        LEAVE_GROUP: '/leave_group',
        GET_LIBRARY_PRICE: '/get_library_price',
        COLLABORATION_REVIEW: '/collaboration_review',
        PLAN_CARD_TEXT: '/plan_card_text',
        UPDATE_AUTO_RENEW: '/update_auto_renew',
        DELET_MESSAGE: '/delete_message',
        DEEP_LINK: '/deep_linking',
        CHAT_USERS_SEARCH: '/chat_users_search',
        // DELETE_CANCELLED_UPLOAD: '/delete_cancelled_upload'
    }
}
